import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { userSchema } from '../user/getUsers';

const deviceSchema = baseObjectSchema.extend({
  code: z.string(),
  name: z.string(),
  remarks: z.string().nullish(),
  updateUser: userSchema.nullish(),
  createUser: userSchema.nullish(),
});

const documentTypeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

const documentSeriesSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

export const getDeviceConfigurationsSchema = z.array(
  baseObjectSchema.extend({
    code: z.string().optional(),
    name: z.string().optional(),
    functionality: z.number(),
    functionalityString: z.string().optional(),
    loadItemLines: z.number(),
    deviceID: z.string(),
    documentTypeID: z.string(),
    documentSeriesID: z.string(),
    defaultUserID: z.string().optional(),
    companySiteID: z.string(),
    device: deviceSchema,
    documentType: documentTypeSchema,
    documentSeries: documentSeriesSchema,
    user: userSchema.optional(),
    companySite: z.object({ id: z.string(), name: z.string() }),
  })
);

export type GetDeviceConfigurationsResponse = z.infer<typeof getDeviceConfigurationsSchema>;
